// Identifies whose data the local storage layer is reading and writing.
//
// Set by AuthContext whenever Firebase resolves the auth state, and read
// synchronously by every storage module. AppProvider only mounts once a user
// is signed in, so the scope is always set before any storage call happens.
//
// Data is keyed by Firebase uid rather than email: a user can change their
// email address, and their workouts should follow them when they do.

let scope = null;
let email = null;
let onDirty = null;

// El correo se guarda aparte del scope y nunca se usa para indexar datos, que
// siguen yendo por uid: solo sirve para decidir con qué arranca una cuenta que
// no tiene nada guardado todavía.
export function setScope(uid, userEmail) {
  scope = uid || null;
  email = userEmail || null;
}

export function getScope() {
  return scope;
}

export function getEmail() {
  return email;
}

// Namespaces a base key to the signed-in user. Falls back to the bare key so
// a logged-out read still returns something sane instead of throwing.
export function scopedKey(baseKey) {
  return scope ? `${baseKey}_${scope}` : baseKey;
}

// Registered by the sync layer so local writes can schedule a push to Firestore.
export function setDirtyHandler(handler) {
  onDirty = handler;
}

export function markDirty(baseKey) {
  if (onDirty && scope) onDirty(baseKey);
}
